import { render, staticRenderFns } from "./VuesticSocialNews.vue?vue&type=template&id=56dd1b5b"
import script from "./VuesticSocialNews.vue?vue&type=script&lang=js"
export * from "./VuesticSocialNews.vue?vue&type=script&lang=js"
import style0 from "./VuesticSocialNews.vue?vue&type=style&index=0&id=56dd1b5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-social-news/VuesticSocialNews.vue
// module id = W3ZV
// module chunks = 41